import { render } from "./nimp_background_selector.vue?vue&type=template&id=6e57da29&scoped=true"
import script from "./nimp_background_selector.vue?vue&type=script&lang=js"
export * from "./nimp_background_selector.vue?vue&type=script&lang=js"

import "./nimp_background_selector.vue?vue&type=style&index=0&id=6e57da29&scoped=true&lang=css"
import "./nimp_background_selector.vue?vue&type=style&index=1&id=6e57da29&lang=css"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6e57da29"]])

export default __exports__